import { createRoute } from '@tanstack/react-router';
import { PujcovnaPage } from '@/modules/pujcovna/PujcovnaPage';
import { Route as RootRoute } from './__root';

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/pujcovna/vozidla',
  component: PujcovnaPage,
});
